import Vue from 'vue'

import Game from './components/Game'

new Vue({
  el: '#app',
  render() {
    return <Game/>
  }
})



// WEBPACK FOOTER //
// ./index.js